import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import MultilineTextInput from './FormInputs/MultilineTextArea';
import TextInput from './FormInputs/TextInput';

FormTextField.propTypes = {
  fieldName: PropTypes.string,
  fieldAttributes: PropTypes.object,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  multiline: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default function FormTextField({
  fieldName,
  fieldAttributes,
  focusedField,
  setFocusedField,
  multiline = false,
  placeholder = '',
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={fieldName}
      control={control}
      rules={{
        required: fieldAttributes?.validation?.required ?? undefined,
        minLength: fieldAttributes?.validation?.minLength ?? undefined,
        pattern: fieldAttributes?.validation?.pattern
          ? {
              value: new RegExp(fieldAttributes?.validation?.pattern.value),
              message: fieldAttributes?.validation?.pattern.message,
            }
          : undefined,
        validate: fieldAttributes?.validation?.validate ?? undefined,
      }}
      render={() => {
        const InputComponent = multiline ? MultilineTextInput : TextInput;

        return (
          <InputComponent
            fieldName={fieldName}
            focusedField={focusedField}
            setFocusedField={setFocusedField}
            fieldAttributes={fieldAttributes}
            placeholder={placeholder}
          />
        );
      }}
    />
  );
}
